<template>
  <VDialog
    v-model="visivel"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
  >
    <LoadingDialog ref="loading" />
    <VCard>
      <VToolbar fixed dense dark color="primary">
        <VToolbarTitle class="subheading">
          <span
            >{{ somenteLeitura ? "Visualizar" : "Preencher" }} formulário</span
          >
        </VToolbarTitle>
        <VSpacer />
        <VToolbarItems>
          <VBtn icon dark @click="imprimir">
            <VIcon> print </VIcon>
          </VBtn>
          <VBtn
            :disabled="requisicaoEmAndamento"
            icon
            dark
            @click="visivel = false"
          >
            <VIcon>close</VIcon>
          </VBtn>
        </VToolbarItems>
      </VToolbar>
      <VContainer ma-0 pa-0 pt-5>
        <VTabs v-model="abaAtiva">
          <VTab :key="0">Ficha</VTab>
          <VTab v-if="mostrarAbaArquivos" :key="1">Fotos</VTab>
          <VTabItem>
            <VContainer ma-0 pa-0>
              <VLayout>
                <VFlex>
                  <div class="bootstrap" id="wrapper">
                    <form
                      ref="formContainer"
                      class="container"
                      id="formRenderContainer"
                    ></form>
                  </div>
                </VFlex>
              </VLayout>
            </VContainer>
          </VTabItem>
          <VTabItem>
            <GaleriaFotos :arquivos="arquivos" :arrayImagem="arrayImagem" />
          </VTabItem>
        </VTabs>
      </VContainer>
      <VFooter fixed dense dark color="primary">
        <VSpacer />
        <Signatarios
          docType="Ficha"
          :visible="telaSignatarios"
          :item="itemSelecionado"
          @close="mostrarFormulario"
        />
        <VBtn
          :disabled="requisicaoEmAndamento"
          v-if="!somenteLeitura"
          flat
          @click="salvar"
        >
          Salvar
        </VBtn>
      </VFooter>
    </VCard>
  </VDialog>
</template>

<script>
import LoadingDialog from "@/components/Dialog/Loading.vue";
import ApiService from "@/common/api.service";
import jQuery from "jquery";
import alerts from "@/common/alerts";
import eventos from "@/common/eventos";
import GaleriaFotos from "./GaleriaFotos";
import forms from "@/common/forms";
import Signatarios from "@/components/Dialog/Signatarios";
import apiConfig from "@/services/apiConfig";

window.jQuery = jQuery;
window.$ = jQuery;

require("jquery-ui-sortable");
require("formBuilder");
require("formBuilder/dist/form-render.min");

export default {
  name: "FormRenderDialog",
  components: {
    Signatarios,
    GaleriaFotos,
    LoadingDialog,
  },
  props: {
    value: Boolean,
    idComanda: Number,
    comandaUsr: Object,
  },
  created() {
    eventos.barramento.$on(eventos.UPPY_CRIADO, (uppy) => {
      this.uppy = uppy;
    });
  },
  data() {
    return {
      itemSelecionado: {},
      abaAtiva: 0,
      uppy: null,
      somenteLeitura: false,
      visivel: false,
      formRender: null,
      idFormulario: null,
      idFormularioPreenchido: null,
      requisicaoEmAndamento: false,
      arquivos: [],
      arrayImagem: [],
      isAssinaturaDigital: false,
      retorno: null,
      telaSignatarios: false,
      docUUID: null,
    };
  },
  watch: {
    visivel(visivel) {
      if (!visivel) {
        this.arquivos = [];
        this.uppy = null;
        this.abaAtiva = 0;
        //this.idFormularioPreenchido = null;
        this.idFormulario = null;
        forms.setQuantidadeFotosSalvas(0);
      }
    },
  },
  methods: {
    async mostrarFormulario(payload) {
      if (this.callbackSalvar)
        this.callbackSalvar(
          this.idFormularioPreenchido,
          this.itemSelecionado.chave
        );
      this.visivel = payload;
      this.$emit("close", this.idComanda);
    },
    imprimir() {

      var winPrint = window.open(
        "a",
        "",
        "left=0,top=0,width=1024,height=768,toolbar=0,scrollbars=0,status=0"
      );

      var conteudo = document.getElementsByClassName("rendered-form")[0].innerHTML;

      winPrint.document.write(`
                <html>
                    <head>
                    <title>Ficha de Anamnese</title>
                    </head>`);

      var styles = [
        "https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.4/jquery.min.js",
        "https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js",
        "https://formbuilder.online/assets/js/form-builder.min.js",
      ];

      styles.forEach((style) => {
        let link = winPrint.document.createElement("script");
        link.setAttribute("src", style);
        winPrint.document.getElementsByTagName("head")[0].appendChild(link);
      });

      var css = [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
      ];

      css.forEach((css) => {
        let link = winPrint.document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", css);
        winPrint.document.getElementsByTagName("head")[0].appendChild(link);
      });

      winPrint.document.write(`
                  <body>
                        ${conteudo}
                  </body>
                </html>`);

      setTimeout(() => {
        winPrint.document.close();
        winPrint.focus();
        winPrint.print();
        winPrint.close();
      }, 333);

    },
    async salvar() {
      let aguardarDialogSignatarios = false;

      if (!this.$refs.formContainer.checkValidity()) {
        await alerts.exibirErro("Preencha todos os campos obrigatórios");
        return;
      }

      this.requisicaoEmAndamento = true;
      try {
        await this.enviarFormulario();
        if (this.uppy) {
          await this.enviarFotos();
        }

        if (this.idFormularioPreenchido) {
          if (jQuery("[id='assinaturaDigital']").val() !== undefined) {
            this.itemSelecionado = {
              idFormularioPreenchido: this.idFormularioPreenchido,
            };

            if (!this.assinaturaConfiguradaCorretamente) {
              this.telaSignatarios = !this.telaSignatarios;
              aguardarDialogSignatarios = true;
            } else {
              this.$notify({
                group: "foo",
                title: "Mensagem importante",
                text: "Não foi encontrada a configuração para assinatura eletrônica! <br> Acesse o menu 'Configurações/Assinatura digital' e insira os dados para integração D4Sign: <br> [TokenAPI, UUIDSafe e CryptKey]",
                type: "error",
                duration: 20000,
                closeOnClick: false,
              });
            }
          }
        }
        if (this.callbackSalvar) {
          this.callbackSalvar(this.idFormularioPreenchido);
        }
      } catch (e) {
        await alerts.exibirErro("Não foi possível salvar o formulário", e);
      } finally {
        this.requisicaoEmAndamento = false;
        if (!aguardarDialogSignatarios) {
          this.visivel = false;
          this.telaSignatarios = false;
        }
      }
    },
    async enviarFormulario() {
      let valores = {
        campos: this.formRender.userData,
      };

      if (!this.idFormularioPreenchido) {
        [this.idFormularioPreenchido] = (
          await this.$refs.loading.aguardarPromises(
            [
              ApiService.post(
                `formularios/${this.idFormulario}/preencher`,
                valores
              ),
            ],
            "Criando formulário"
          )
        ).map((r) => r.data);
      } else
        await this.$refs.loading.aguardarPromises(
          [
            ApiService.put(
              `formularios/preenchidos/${this.idFormularioPreenchido}`,
              valores
            ),
          ],
          "Atualizando formulário"
        );
    },
    async enviarFotos() {
      var plugin = this.uppy.getPlugin("XHRUpload");
      plugin.opts.endpoint = `${apiConfig.getUrlAgendaServicosApi()}/api/formularios/preenchidos/${
        this.idFormularioPreenchido
      }/anexos`;
      plugin.opts.headers = {
        Authorization: apiConfig.getToken(),
      };
      plugin.opts.getResponseError = (r) =>
        Error(alerts.extrairMensagemErro(JSON.parse(r)));
      plugin.opts.getResponseData = () => ({ url: null });
      let retornos = await Promise.all([
        this.uppy.retryAll(),
        this.uppy.upload(),
      ]);
      let falhas = retornos.flatMap((r) => r.failed);
      if (falhas.length > 0) {
        var detalhe = falhas.map((f) => f.error).join("; ");
        throw Error(detalhe);
      }
    },
    async preencher(idFormulario, callbackSalvar, evento) {
      this.idFormularioPreenchido = null;
      let [form] = (
        await this.$refs.loading.aguardarPromises([
          ApiService.get(`formularios/${idFormulario}`),
        ])
      ).map((r) => r.data);
      this.idFormulario = idFormulario;
      this.callbackSalvar = callbackSalvar;
      this.somenteLeitura = false;
      this.renderizar(form.codigoFonte.campos, evento);
    },
    async visualizar(param, somenteLeitura = true, evento) {
      let form = null;
      if (typeof param === "number") {
        let [retorno] = (
          await this.$refs.loading.aguardarPromises([
            ApiService.get(`formularios/preenchidos/${param}`),
          ])
        ).map((r) => r.data);
        form = retorno.valores.campos;
        this.idFormularioPreenchido = param;
        this.arquivos = retorno.arquivos;

        this.arrayImagem = await this.getArrayImagem();

        forms.setQuantidadeFotosSalvas(this.arquivos.length);
      } else form = param;
      this.somenteLeitura = somenteLeitura;
      this.renderizar(form, evento);
    },
    async enviarEAguardarBackend(promises, texto) {
      try {
        this.requisicaoEmAndamento = true;
        return await this.$refs.loading.aguardarPromises(promises, texto);
      } finally {
        this.requisicaoEmAndamento = false;
      }
    },

    async consultaCliente(id) {
      try {
        return (
          await ApiService.get(`clientes/dadosClienteParaFormulario/${id}`)
        ).data;
      } catch (e) {
        alerts.exibirErro("Erro ao buscar dados do cliente", e);
        return;
      }
    },

    async getArrayImagem() {
      var src = [];

      for (let i of this.arquivos) {
        var srcAux = await ApiService.getImage(
          `arquivos/`,
          `${i.guid}?t=${i.t}&h=${i.h}`
        );
        src.push({ guid: i.guid, src: srcAux });
      }

      return this.arquivos.map((a) => ({
        src: URL.createObjectURL(
          src.filter((i) => i.guid == a.guid)[0].src.data
        ),
        w: a.metadados.w,
        h: a.metadados.h,
      }));
    },

    async getImagens() {
      var src = [];

      for (let i of this.arquivos) {
        var srcAux = await ApiService.getImage(
          `arquivos/`,
          `${i.guid}?t=${i.t}&h=${i.h}`
        );
        src.push({ guid: i.guid, src: srcAux });
      }

      return this.arquivos.map((a) => ({
        src: URL.createObjectURL(
          src.filter((i) => i.guid == a.guid)[0].src.data
        ),
        w: a.metadados.w,
        h: a.metadados.h,
      }));
    },

    async renderizar(dados, evento) {
      if (evento != undefined) {
        let posicaoComanda, posicaoUser;
        posicaoComanda = dados.findIndex((e) => e.type === "comandaData");
        posicaoUser = dados.findIndex((e) => e.type === "userData");

        if (posicaoComanda != -1) {
          if (dados[posicaoComanda].hasOwnProperty("dataAtendimento")) {
            if (evento.hora.length > 6) {
              let dateAux = evento.hora.split("T")[0];
              var p = dateAux.split(/\D/g);
              dados[posicaoComanda].dataAtendimento = [p[2], p[1], p[0]].join(
                "/"
              );
            } else {
              let dateAux = evento.data;
              var spliteDataAux = dateAux ? dateAux.split(/\D/g) : '00/00/0000'

              dados[posicaoComanda].dataAtendimento = dateAux ? [
                spliteDataAux[2],
                spliteDataAux[1],
                spliteDataAux[0],
              ].join("/") : spliteDataAux
            }
          }

          if (dados[posicaoComanda].hasOwnProperty("horaAtendimento")) {
            if (evento.hora.length < 6)
              dados[posicaoComanda].horaAtendimento = evento.hora;
            else {
              let horaAux = evento.hora.split("T")[1];
              var splitedHour = horaAux.split(":");
              dados[posicaoComanda].horaAtendimento = [
                splitedHour[0],
                splitedHour[1],
              ].join(":");
            }
          }

          if (dados[posicaoComanda].hasOwnProperty("numComanda"))
            dados[posicaoComanda].numComanda = this.comandaUsr.id;

          if (dados[posicaoComanda].hasOwnProperty("servico"))
            dados[posicaoComanda].servico = evento.servico.nome;

          if (dados[posicaoComanda].hasOwnProperty("franquia"))
            dados[posicaoComanda].franquia =
              this.$store.state.parametros.franquia.nome;

          if (dados[posicaoComanda].hasOwnProperty("profissionalResponsavel"))
            dados[posicaoComanda].profissionalResponsavel =
              evento.profissionais.responsavel.nomeFantasia;
        }

        if (posicaoUser != -1) {
          let cliente = await this.consultaCliente(this.comandaUsr.cliente.id);

          if (dados[posicaoUser].hasOwnProperty("nomeCliente"))
            dados[posicaoUser].nomeCliente = cliente.nome;

          if (dados[posicaoUser].hasOwnProperty("dataNascimento")) {
            let dateAux = cliente.dataNascimento;
            if (dateAux != null) {
              var splitedData = dateAux.split(/\D/g);
              dados[posicaoUser].dataNascimento = [
                splitedData[2],
                splitedData[1],
                splitedData[0],
              ].join("/");
            } else dados[posicaoUser].dataNascimento = "";
          }

          if (dados[posicaoUser].hasOwnProperty("telefone")) {
            if (this.comandaUsr.telefone != null)
              dados[posicaoUser].telefone =
                this.comandaUsr.cliente.telefone.numero;
            else dados[posicaoUser].telefone = "";
          }

          if (dados[posicaoUser].hasOwnProperty("cpf")) {
            if (cliente.documento != null && cliente.documento != "")
              dados[posicaoUser].cpf = cliente.documento;
          }

          if (dados[posicaoUser].hasOwnProperty("rg")) {
            if (cliente.rg != null && cliente.rg != "") {
              if (cliente.rg == "ISENTO") dados[posicaoUser].rg = "";
              else dados[posicaoUser].rg = cliente.rg;
            }
          }

          if (dados[posicaoUser].hasOwnProperty("email")) {
            if (cliente.email != null && cliente.email != "")
              dados[posicaoUser].email = "";
            else dados[posicaoUser].email = cliente.email;
          }
        }
      }

      this.formRender = jQuery(this.$refs.formContainer).formRender({
        formData: dados.map(dado => ({
          ...dado, value: dado.userData
        })),
        dataType: "json",
      });

      if (this.somenteLeitura)
        jQuery("input, textarea, select", "#formRenderContainer")
          .attr("readonly", true)
          .attr("disabled", true);
      this.visivel = true;
    },
  },
  computed: {
    mostrarAbaArquivos() {
      return this.arquivos.length > 0;
    },
  },
};
</script>

<style lang="less">
.bootstrap {
  @import (less) "~@/assets/bootstrap.min.css";
  @import (less) "~@/assets/bootstrap-theme.min.css";
}

@import "~@/assets/forms.css";
</style>
